const mimes = {
    ZIP: ['application/zip', 'application/x-zip-compressed'],
    WORD: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    CONFIGURATION_DOCUMENT_ALLOWED_TYPES: ['application/pdf']
}

export default mimes;